<template>
    <v-dialog v-model="objFormModal.abrirModal" :width="objFormModal.size" :scrollable="$root.isTouch == false"
        :fullscreen="$root.isTouch" persistent>
        <v-card elevation="11">
            <v-card-title class="bg-title-card"> 
                <span class="white--text headline" v-html="objFormModal.titulo"></span>
            </v-card-title>
            <v-card-text>
                <v-form ref="form_modal_accesorio" :lazy-validation="true">
                    <v-container fluid grid-list-sm>
                        <!-- Radio -->
                        <template
                            v-if="objFormModal.id_accesorio == parametrosAccesorios.id_accesorio_radio_wizard">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Marca *" color="textbox" v-model.trim="objFormModal.marca"
                                        :rules="requeridoRegla" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Modelo *" color="textbox"
                                        v-model.trim="objFormModal.modelo" outlined dense :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Cantidad *" color="textbox"
                                        v-model.number="objFormModal.cantidad"
                                        :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                                </v-col>
                            </v-row>
                        </template>
                        <!-- Fin Modal Radio  -->

                        <!-- Llantas -->
                        <template
                            v-else-if="objFormModal.id_accesorio == parametrosAccesorios.id_accesorio_llantas_wizard">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Anchura del Neumático *" color="textbox"
                                        v-model.trim="objFormModal.anchura" :rules="requeridoRegla" outlined
                                        dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Rin *" color="textbox" v-model.trim="objFormModal.rin"
                                        outlined dense :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Perfil *" color="textbox"
                                        v-model.trim="objFormModal.perfil" :rules="requeridoRegla" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Cantidad *" color="textbox"
                                        v-model.number="objFormModal.cantidad"
                                        :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                                </v-col>
                            </v-row>
                        </template>
                        <!-- Fin Modal Llantas -->

                        <!-- Aros -->
                        <template
                            v-else-if="objFormModal.id_accesorio == parametrosAccesorios.id_accesorio_aros_wizard">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Marca *" color="textbox" v-model.trim="objFormModal.marca"
                                        :rules="requeridoRegla" outlined dense />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Rin *" color="textbox" v-model.trim="objFormModal.rin"
                                        outlined dense :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Cantidad *" color="textbox"
                                        v-model.number="objFormModal.cantidad"
                                        :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                                </v-col>
                            </v-row>
                        </template>
                        <!-- Fin Modal Aros -->

                        <!-- Otros -->
                        <template
                            v-else-if="objFormModal.id_accesorio == parametrosAccesorios.id_accesorio_otros_wizard">
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Descripcion *" color="textbox"
                                        v-model.trim="objFormModal.descripcion" outlined dense
                                        :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Marca *" color="textbox" v-model.trim="objFormModal.marca"
                                        outlined dense :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Modelo *" color="textbox"
                                        v-model.trim="objFormModal.modelo" outlined dense :rules="requeridoRegla" />
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12">
                                    <v-text-field label="Cantidad *" color="textbox"
                                        v-model.number="objFormModal.cantidad"
                                        :rules="_.concat(requeridoRegla,numeroRegla)" outlined dense />
                                </v-col>
                            </v-row>
                        </template>
                        <!-- Fin Modal Otros -->

                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-text-field label="Valor Asegurado *" color="textbox"
                                    v-model.number="objFormModal.valorAsegurado"
                                    :rules="_.concat(requeridoRegla,decimal,reglaValorMax)" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12">
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-file-input :rules="requeridoRegla"
                                            accept="image/jpg,image/jpeg,image/png"
                                            @change="onloadFactura" prepend-icon="add_a_photo"
                                            label="Foto de Factura *" color="textbox" outlined dense
                                            v-model="objFormModal.name_factura"></v-file-input>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-file-input :rules="requeridoRegla"
                                            accept="image/jpg,image/jpeg,image/png"
                                            @change="onloadFoto" prepend-icon="add_a_photo"
                                            label="Foto de Accesorio *" color="textbox" outlined dense
                                            v-model="objFormModal.name_foto"></v-file-input>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" class="text-center mt-3 mb-3">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="onCargaGeneral">Salir</v-btn>
                                <v-btn outlined rounded color="danger" class="mr-1" @click="addAccesorio($event,true)" :disabled="_.isUndefined(objFormModal.index)">Eliminar</v-btn>
                                <v-btn rounded dark color="primary" @click="addAccesorio">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        // props: ['objModal', 'parametrosAccesorios', 'porc_casco_permitir_valor_accesorio_adicional', 'valorCasco'],
        props:{
            objModal:{type: Object, default:{}},
            parametrosAccesorios:{type: Object, default:{}},
            porc_casco_permitir_valor_accesorio_adicional:{type: Number, default:0},
            valorCasco:{type: Number, default:0}
        },
        inject: ['addListAccesorio'],
        data() {
            return {
                objFormModal: {
                    titulo: 'Información de Accesorio',
                    abrirModal: false
                },
                valorMaxAccesorio: 0
            }
        },
        watch: {
            objModal: {
                handler(val) {
                    if (val.abrirModal) {
                        this.objFormModal = _.clone(this.objModal);
                        this.valorMaxAccesorio = (parseFloat(this.valorCasco) * parseFloat(this.porc_casco_permitir_valor_accesorio_adicional)) / 100;
                        
                        if(!_.isUndefined(this.$refs.form_modal_accesorio))
                            this.$refs.form_modal_accesorio.resetValidation();
                    }
                },
                deep: true
            }
        },
        computed: {
            reglaValorMax() {
                var valor = _.clone(this.valorMaxAccesorio);
                if (parseInt(this.objFormModal.genera_solicitud) == 0)
                    return [v => v <= valor || `Debe ingresar un valor máximo hasta $ ${valor}`]
                else
                    return [];
            }
        },
        methods: {
            onCargaGeneral() {
                this.objFormModal = {
                    titulo: 'Información de Accesorio',
                    abrirModal: false
                };

                if(!_.isUndefined(this.$refs.form_modal_accesorio))
                    this.$refs.form_modal_accesorio.resetValidation();
            },
            addAccesorio(e, remove = false) {
                try {
                    if (!this.$refs.form_modal_accesorio.validate()) throw mensajeEstandar.corregirInformacion;
                    if(this.validateMime(this.objFormModal,'factura')) throw mensajeEstandar.archivo;
                    if(this.validateMime(this.objFormModal,'foto')) throw mensajeEstandar.archivo;
                        this.addListAccesorio(this.objFormModal, remove)
                            .then((r)=>{
                                if(r) throw 'Error al agregar accesorio.'
                                    this.onCargaGeneral();
                            })
                            .catch((e)=>{
                                mensajesAlerta(e,'E');
                            })
                } catch (error) {
                    mensajesAlerta(error, 'E');
                }
            },
            validateMime(objeto,key){
                var band = false;            
                if(!_.includes(_.get(objeto,key,''),'data:image/png') && !_.includes(_.get(objeto,key,''),'.data:image/jpg') &&  !_.includes(_.get(objeto,key,''),'data:image/jpeg'))
                    band = true;
                
                return band;
            },
            onloadFactura(){
                try {
                    var files = _.get(this.objFormModal,'name_factura',undefined);
                    if(_.isUndefined(files)) throw mensajeEstandar.archivo;
                    if ((files.name.search('.png') == -1) && (files.name.search('.jpg') == -1) && (files.name.search('.jpeg') == -1)) throw mensajeEstandar.archivo;
                    var reader = new FileReader();
                        reader.readAsDataURL(_.get(this.objFormModal,'name_factura'),null);
                        reader.onload = () => {
                            this.$set(this.objFormModal,'factura',reader.result);
                        };
                } catch (e) {
                    this.$set(this.objFormModal, 'factura', undefined);
                    this.$set(this.objFormModal, 'name_factura', undefined);
                    mensajesAlerta(e,'E');
                }
            },
            onloadFoto(){
                try {
                    var files = _.get(this.objFormModal,'name_foto',undefined);
                    if(_.isUndefined(files)) throw mensajeEstandar.archivo;
                    if ((files.name.search('.png') == -1) && (files.name.search('.jpg') == -1) && (files.name.search('.jpeg') == -1)) throw mensajeEstandar.archivo;
                        var reader = new FileReader();
                            reader.readAsDataURL(_.get(this.objFormModal,'name_foto',null));
                            reader.onload = () => {
                                this.$set(this.objFormModal,'foto',reader.result);
                            };
                } catch (e) {
                    this.$set(this.objFormModal, 'foto', undefined);
                    this.$set(this.objFormModal, 'name_foto', undefined);
                    mensajesAlerta(e,'I');
                }
            }
        }
    }
</script>